'use client'

import { useCookieConsent } from '@/contexts/CookieConsentContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import Link from 'next/link';
import { X, Settings } from 'lucide-react';

export default function CookieConsentBanner() {
  const {
    showBanner,
    acceptAllCookies,
    rejectNonEssentialCookies,
    openSettings
  } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  const handleDismiss = () => {
    // Dismissing banner implies accepting current state (essential only)
    rejectNonEssentialCookies();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="mx-auto max-w-4xl border-2 shadow-lg">
        <CardContent className="p-6">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <h3 className="text-lg font-semibold mb-2">Cookie Preferences</h3>
              <p className="text-sm text-muted-foreground mb-4">
                We use cookies to enhance your experience, analyze site usage, and assist in our marketing efforts.
                Essential cookies are required for the site to function properly and are always enabled.
                You can choose to accept or decline optional cookies.
              </p>

              <div className="flex flex-wrap gap-2 mb-4">
                <Button
                  onClick={acceptAllCookies}
                  className="bg-primary hover:bg-primary/90"
                >
                  Accept All Cookies
                </Button>
                <Button
                  onClick={rejectNonEssentialCookies}
                  variant="outline"
                >
                  Reject Non-Essential
                </Button>
                <Button
                  onClick={openSettings}
                  variant="outline"
                  className="flex items-center gap-2"
                >
                  <Settings className="h-4 w-4" />
                  Manage Preferences
                </Button>
              </div>

              <p className="text-xs text-muted-foreground">
                By continuing to use our site, you agree to our{' '}
                <Link href="/cookie-policy" className="underline hover:no-underline">
                  Cookie Policy
                </Link>
                {' '}and{' '}
                <Link href="/privacy-policy" className="underline hover:no-underline">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>

            <Button
              onClick={handleDismiss}
              variant="ghost"
              size="sm"
              className="flex-shrink-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}